import { getServizioAssicurativoUid } from '../../utils/findomesticUtils'
import { ModeSettingsHelper } from '../settings'

export const FINANCING_SETTINGS_MODES = {
  ONLY_QUOTATION: 'ONLY_QUOTATION',
}

export class FinancingSettingsHelper extends ModeSettingsHelper {
  _financements

  constructor(settings, financements = null) {
    super(settings)

    this.addIdsToSchemas(this._settings)
    this._financements = financements
  }

  get hasInsuranceProducts() {
    return !!this._financements?.custom?.insurance_product?.length
  }

  get isFinancingOnlyQuotation() {
    return (
      FINANCING_SETTINGS_MODES.ONLY_QUOTATION ===
      this._settings?.mode?.toUpperCase()
    )
  }

  get isPrivateEmployee() {
    return this._financements?.custom?.private_employee
  }

  get residenceProvince() {
    return this._financements?.custom?.residence_province
  }

  getProductDuration(product) {
    return this._financements?.custom?.insurance_product.find(
      item =>
        product.codice_prodotto_assicurativo ===
        item.codice_prodotto_assicurativo
    )?.durata_copertura
  }

  includeProduct(product) {
    return this._financements?.custom?.insurance_product.find(
      item =>
        product.codice_prodotto_assicurativo ===
        item.codice_prodotto_assicurativo
    )
  }

  mapSelectedFindomesticProducts(products) {
    if (!this.hasInsuranceProducts) {
      return []
    }

    const selectedProducts = []
    for (const product of products) {
      this.includeProduct(product) &&
        selectedProducts.push(getServizioAssicurativoUid(product))
    }

    return selectedProducts
  }
}
